<template>
  <div class="q-gutter-sm">
    <q-checkbox
      :model-value="isAll"
      label="All"
      @update:modelValue="selectAll"
    />
    <br />
    <q-checkbox
      :model-value="isOnTimeline"
      label="Timeline"
      @update:modelValue="toggleTimeline"
    />
    <q-checkbox
      v-for="status in statuses"
      :key="status.value"
      :model-value="isSelected(status.value)"
      :label="status.label"
      @update:modelValue="toggleStatus(status.value)"
    />
    <q-checkbox
      :model-value="isFlagged"
      label="Flagged"
      @update:modelValue="toggleFlagged"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { PostFilters } from '@/type';
import { status } from './post';

interface Option {
  value: number,
  label: string,
}

interface Data {
  statuses: Option[],
}

export default defineComponent({
  emits: ['update:filters'],
  props: {
    filters: Object as () => PostFilters,
  },
  data(): Data {
    return {
      statuses: [
        {
          value: status.UNREVIEWED,
          label: 'Unreviewed',
        },
        {
          value: status.ESCALATED,
          label: 'Escalated',
        },
        {
          value: status.RESOLVED,
          label: 'Resolved',
        },
      ],
    };
  },
  computed: {
    isAll(): boolean {
      return (
        this.filters.isOnTimeline === true
        && this.filters.isFlagged === true
        && _.isEqual(this.filters.statuses, this.statuses.map(s => s.value))
      );
    },
    isOnTimeline(): boolean {
      return this.filters.isOnTimeline || false;
    },
    isFlagged(): boolean {
      return this.filters.isFlagged || false;
    },
  },
  methods: {
    isSelected(value: number): boolean {
      return this.filters.statuses.includes(value);
    },
    toggleStatus(value: number) {
      const index = this.filters.statuses.findIndex(s => s === value);
      const statuses = _.clone(this.filters.statuses);
      if (index >= 0 && (this.isOnTimeline || this.isFlagged || statuses.length > 1)) {
        statuses.splice(index, 1);
      } else {
        statuses.push(value);
      }
      this.$emit('update:filters', Object.assign({}, this.filters, {
        statuses,
      }));
    },
    toggleTimeline() {
      if (this.isOnTimeline && !this.isFlagged && !this.filters.statuses.length) return;
      this.$emit('update:filters', Object.assign({}, this.filters, {
        isOnTimeline: this.isOnTimeline ? undefined : true,
      }));
    },
    toggleFlagged() {
      if (this.isFlagged && !this.isOnTimeline && !this.filters.statuses.length) return;
      this.$emit('update:filters', Object.assign({}, this.filters, {
        isFlagged: this.isFlagged ? undefined : true,
      }));
    },
    selectAll() {
      if (this.isAll) return;
      this.$emit('update:filters', {
        isOnTimeline: true,
        isFlagged: true,
        statuses: this.statuses.map(s => s.value),
      });
    },
  },
});
</script>
